const productFeaturesTemplate = document.querySelector('template#product-features')

export default class ProductFeatures extends HTMLElement {
  constructor() {
    super();
    this.renderTemplate();
  }

  connectedCallback() {
    // Invoked each time the custom element is appended into DOM.
  }

  disconnectedCallback() {
    // Invoked each time the custom element is disconnected from the document's DOM.
  }

  renderTemplate() {
    // shadow DOM need its own css
    // this.attachShadow({ mode: 'open' });
    // this.shadowRoot.appendChild(template.content.cloneNode(true));

    // This is not Shadow DOM - can apply global css here.
    this.appendChild(productFeaturesTemplate.content.cloneNode(true));
  }

}
window.customElements.define('product-features', ProductFeatures);